import "@fontsource/roboto";
import "./src/styles/foundation/variable.css";
import "./src/styles/foundation/normalize.css";
import "./src/styles/foundation/base.css";
import "./src/styles/foundation/blog-contents-style.css";

export const onRouteUpdate = () => {
  if (typeof document === "undefined") return;

  const selectors = [
    ".fadeInUp",
    ".fadeInRight",
    ".fadeInLeft",
    ".fadeInBlur",
    ".fadeInLeftMedia",
    ".fadeInRightMedia",
    ".fadeInMarker"
  ];

  const elements = selectors.flatMap(selector => Array.from(document.querySelectorAll(selector)));

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("on");
        }
      });
    },
    { threshold: 0.7 }
  );

  elements.forEach(el => observer.observe(el));

  return () => {
    elements.forEach(el => observer.unobserve(el));
  };
};